module.exports = __webpack_public_path__ + "static/img/7.5adff9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/7.png
// module id = nwpN
// module chunks = 35